import * as Types from '../../../_generated/types.d';

import { GeocodeResponseData } from "@googlemaps/google-maps-services-js";
import { CoachState } from "@portal/app/_common/lib/coach";
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';
import { DreamSearchItemFragmentFragmentDoc } from '../generated';
export type GetFavoritedDreamSearchItemsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetFavoritedDreamSearchItemsQuery = { __typename?: 'Query', getFavoritedDreamSearchItems: Array<{ __typename?: 'DreamSearchItem', id: string, score: number, distance: number, favorited: boolean, label: Types.ProgramTag | null, provider: { __typename?: 'Provider', id: string, fullName: string, isPartnered: boolean, slug: string, complianceExclusionTags: Array<string>, logoImageFile: { __typename?: 'ImageFile', id: string, url: string | null } | null, publicDisplayFields: { __typename?: 'ProviderPublicDisplayFields', id: string, aboutSchool: string | null } | null, geocode: { __typename?: 'Geocode', id: string, point: {
          lat: number;
          long: number;
        } }, detailsMap: { __typename?: 'ProviderDetailMap', id: string, logoPalette: { __typename?: 'LogoPalette', muted: string | null } | null } }, program: { __typename?: 'Program', id: string, environment: Types.ProgramEnvironment, environmentCompliance: boolean, name: string, slug: string, customCtaCopy: string | null, preLeadRedirect: string | null, preLeadRedirectParams: {
        [key: string]: any;
      } | null, preLeadRedirectCompositeParams: {
        [key: string]: any;
      } | null, preLeadRedirectSuppressDefaultParams: boolean | null, preLeadRedirectInIframe: boolean | null, allowHybridSignup: boolean, programHighlights: Array<string>, tags: Array<Types.ProgramTag>, programLevel: Types.ProgramLevel, publicDisplayFields: { __typename?: 'ProgramPublicDisplayFields', id: string, aboutProgramPlainText: string | null } | null, vocation: { __typename?: 'Vocation', id: string, abbreviation: string | null, adjective: string }, costs: Array<{ __typename?: 'ProgramCost', id: string, cost: number }>, eligiblePaymentOptions: Array<{ __typename?: 'PaymentOption', id: string, type: Types.PaymentOptionType, estimatedFirstPayment: number | null, isVisible: boolean, config: { __typename?: 'PaymentOptionConfig', id: string, description: string | null } }> } }> };

export type OptimisticDreamSearchItemFragment = { __typename?: 'DreamSearchItem', id: string, favorited: boolean };

export type ToggleFavoriteEnrollmentItemForDreamSearchMutationVariables = Types.Exact<{
  customerId: Types.Scalars['ID']['input'];
  programId: Types.Scalars['ID']['input'];
}>;


export type ToggleFavoriteEnrollmentItemForDreamSearchMutation = { __typename?: 'Mutation', toggleFavoriteEnrollmentItem: { __typename?: 'EnrollmentItem', id: string, programId: string, status: Types.EnrollmentStatus, provider: { __typename?: 'Provider', id: string, fullName: string }, program: { __typename?: 'Program', id: string, name: string, vocation: { __typename?: 'Vocation', id: string, adjective: string } } } | null };

export const OptimisticDreamSearchItemFragmentDoc = gql`
    fragment OptimisticDreamSearchItem on DreamSearchItem {
  id
  favorited
}
    ` as unknown as DocumentNode<OptimisticDreamSearchItemFragment, unknown>;
export const GetFavoritedDreamSearchItemsDocument = gql`
    query getFavoritedDreamSearchItems {
  getFavoritedDreamSearchItems {
    ...DreamSearchItemFragment
  }
}
    ${DreamSearchItemFragmentFragmentDoc}` as unknown as DocumentNode<GetFavoritedDreamSearchItemsQuery, GetFavoritedDreamSearchItemsQueryVariables>;
export const ToggleFavoriteEnrollmentItemForDreamSearchDocument = gql`
    mutation toggleFavoriteEnrollmentItemForDreamSearch($customerId: ID!, $programId: ID!) {
  toggleFavoriteEnrollmentItem(programId: $programId, customerId: $customerId) {
    id
    programId
    status
    provider {
      id
      fullName
    }
    program {
      id
      name
      vocation {
        id
        adjective
      }
    }
  }
}
    ` as unknown as DocumentNode<ToggleFavoriteEnrollmentItemForDreamSearchMutation, ToggleFavoriteEnrollmentItemForDreamSearchMutationVariables>;